module.exports = __webpack_public_path__ + "media/patterns/LightBlueCurve-8092a91c.svg";